import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../../../../public/assets/mlLogos/logo-white-font.png'


const _hoisted_1 = { class: "pdfViewerHeader" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "container flex items-end" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "ml_icon",
    class: "logo mr-4"
  })
], -1)
const _hoisted_3 = { class: "viewerHolder" }
const _hoisted_4 = {
  id: "pdfViewer",
  ref: "pdfViewerRef"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_ion_header, null, {
      default: _withCtx(() => [
        _createVNode(_component_ion_toolbar, {
          color: "red",
          class: "text-white flex items-end ml-background ion-no-border"
        }, {
          default: _withCtx(() => [
            _hoisted_2
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, null, 512)
    ])
  ]))
}